import { Component, Input } from '@angular/core';

import { IWebcastViewContext } from 'rev-shared/webcast/webcastView/IWebcastViewContext';

import { INotifications } from 'rev-portal/scheduledEvents/webcast/Webcast.Contract';
import { WebcastModel } from 'rev-portal/scheduledEvents/webcast/model/WebcastModel';

@Component({
	selector: 'vb-webcast-questions-sidebar',
	template: `
		<vb-webcast-manage-question-sidebar
			*ngIf="webcast.currentUser.canManageQuestions; else attendeeQuestions"
			[webcast]="(webcast.webcast$ | async)"
			[context]="context">
		</vb-webcast-manage-question-sidebar>
		<ng-template #attendeeQuestions>
			<vb-webcast-attendee-question-sidebar
				[webcast]="(webcast.webcast$ | async)"
				[sidebarNotifications]="sidebarNotifications"
				[context]="context">
			</vb-webcast-attendee-question-sidebar>
		</ng-template>
	`,
	host: {
		class: 'box-block height-full ps-3 pe-3'
	},
	standalone: false
})
export class VbWebcastQuestionsSidebarComponent {
	@Input() public webcast: WebcastModel;
	@Input() public sidebarNotifications: INotifications;
	@Input() public context: IWebcastViewContext;
}
